import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";

interface RadioOption {
	id: number;
	value: string;
}

interface RadioOptionStepProps {
	value: number | null;
	onChange: (value: number) => void;
	options: RadioOption[];
	error?: string;
}

export default function RadioOptionStep({ value, onChange, options, error }: RadioOptionStepProps) {
	return (
		<FormControl fullWidth error={!!error}>
			<RadioGroup value={value ?? ""} onChange={(e) => onChange(Number(e.target.value))}>
				{options.map((option) => (
					<FormControlLabel
						key={option.id}
						control={<Radio />}
						label={option.value}
						sx={{
							"& .MuiFormControlLabel-label": {
								marginBottom: 0,
							},
						}}
						value={option.id}
					/>
				))}
			</RadioGroup>
		</FormControl>
	);
}
